import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userData, setUserData] = useState(null);
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const storedData = localStorage.getItem("userData");
        if (storedData) {
            setUserData(JSON.parse(storedData));
            setIsAuthenticated(true);
        }
        setIsLoading(false)
    }, []);

    const contextValue = useMemo(() => ({
        isAuthenticated, userData, isLoading,

        signIn: (data, navigate) => {
            if (data && data?.data?.auth_token) {
                console.log("userData",data)
                localStorage.setItem("userData", JSON.stringify(data));
                setUserData(data);
                setIsAuthenticated(true);
                // navigate("/home");
                // window.location = '/demo/home'
                window.location = '/home'
            } else {
                console.error("Sign in failed: Invalid credentials or inactive account.");
            }
        },

        signOut: (navigate) => {
            localStorage.removeItem("userData");
            setUserData(null);
            setIsAuthenticated(false);
            navigate('/login', { replace: true });
        }
    }), [isAuthenticated, userData, isLoading]);

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};
